/**
 * Campaign copy.
 *
 * ⚠ PROVISIONAL — blocker B12 ("Is the campaign headline and tagline signed
 * off?") is OPEN. Both answers on it sit at status `blocked`: Brand DNA work is
 * still deciding brand voice, and one of the two named owners is on leave until
 * May 2027.
 *
 * David's call on 29 Aug was to use the line from the marketing mockup now and
 * change it later if needed, and he re-confirmed it the same day against two
 * alternatives ("Same crew. One ConeTec." and "Same ground. Same crew. One
 * ConeTec."). That is a considered internal preference, NOT a Comms sign-off —
 * B12 is still open and Brand DNA can still land somewhere else. So the copy
 * lives here, in exactly one place, named for what it is, rather than being
 * scattered through components. When B12 closes, this file is the only thing
 * that changes.
 *
 * Do not copy these strings into a component. Import them.
 */

export const PROVISIONAL_CAMPAIGN_COPY = {
  /** From the marketing mockup (Conetec-OneConetec Portal-Banner-03). */
  headline: 'Same ground. Same crews. One name.',
  subhead:
    // 15 April 2027 is the PUBLIC launch — the rebrand going to market. It said
    // "13 October" until 21 Sep; that is the EMPLOYEE launch of this hub, and
    // the sentence is about the market (David, 21 Sep, reading it on prod).
    'On 15 April, Conetec, Mud Bay Drilling, Geotech Drilling and Lankelma go to market under one identity. Nothing about how the work gets done changes.',
} as const

/** Milestone dates. Fixed points, not derived from the viewer's clock — rule 9. */
export const LAUNCH = {
  previewLabel: '7 Oct preview',
  launchLabel: '13 Oct launch',
} as const
